const form = {
	display_name: {
		helper: "Geef uw daDup-account een weergave-naam.",
		label: "Weergave-naam",
		placeholder: "Bucket_Holder_01",
		placeholder_example: "Bijvoorbeeld: Bucket_Holder_01",
	},
};

export default form;
